import { UserType } from '../types/alarm';

export interface LicenseLimitConfig {
  maxClasses: number | null; // null = 무제한
  maxStudentsPerClass: number | null;
  maxAssignmentsPerMonth: number | null;
  maxStorageMB: number | null;
  maxQuizSets: number | null; // 문제 세트 수 제한
  maxQuizCardsPerSet: number | null; // 문제 세트당 문제 카드 수 제한
  maxAlarmSets: number | null; // 알람 세트 수 제한
  allowedAlarmCategories: string[]; // 허용된 알람 카테고리 목록
  maxNoteCategories: number | null; // 노트 카테고리 수 제한
  maxMemberGroups: number; // 멤버 그룹 최대 개수 (1, 2, 15 등)
}

export const LICENSE_LIMITS: Record<UserType, LicenseLimitConfig> = {
  free: {
    maxClasses: 1,
    maxStudentsPerClass: 30,
    maxAssignmentsPerMonth: 10,
    maxStorageMB: 100,
    maxQuizSets: 1, // 문제 세트 1개
    maxQuizCardsPerSet: 10, // 문제 세트당 문제 카드 10개
    maxAlarmSets: 1, // 알람 세트 1개
    allowedAlarmCategories: ['basic'], // 기본 알람만
    maxNoteCategories: 1, // 노트 카테고리 1개
    maxMemberGroups: 1,
  },
  basic: {
    maxClasses: 1,
    maxStudentsPerClass: 30,
    maxAssignmentsPerMonth: null, // 무제한
    maxStorageMB: 500,
    maxQuizSets: 1, // 문제 세트 1개
    maxQuizCardsPerSet: 10, // 문제 세트당 문제 카드 10개
    maxAlarmSets: 3, // 알람 세트 3개
    allowedAlarmCategories: ['basic', 'class'], // 모든 알람 카테고리
    maxNoteCategories: 2, // 노트 카테고리 2개
    maxMemberGroups: 1,
  },
  standard: {
    maxClasses: 2,
    maxStudentsPerClass: 35,
    maxAssignmentsPerMonth: null, // 무제한
    maxStorageMB: 2048, // 2GB
    maxQuizSets: 10, // 문제 세트 10개
    maxQuizCardsPerSet: 30, // 문제 세트당 문제 카드 30개
    maxAlarmSets: 5, // 알람 세트 5개
    allowedAlarmCategories: ['basic', 'class'], // 모든 알람 카테고리
    maxNoteCategories: 5, // 노트 카테고리 5개
    maxMemberGroups: 2, // 스탠다드: 최대 2개 그룹
  },
  pro: {
    maxClasses: 5,
    maxStudentsPerClass: 35,
    maxAssignmentsPerMonth: null, // 무제한
    maxStorageMB: null,
    maxQuizSets: 20, // 문제 세트 20개
    maxQuizCardsPerSet: 30, // 문제 세트당 문제 카드 30개
    maxAlarmSets: 10, // 알람 세트 10개
    allowedAlarmCategories: ['basic', 'class'], // 모든 알람 카테고리
    maxNoteCategories: 5, // 노트 카테고리 5개
    maxMemberGroups: 15,
  },
  admin: {
    maxClasses: 5, // 프로 플랜과 동일
    maxStudentsPerClass: 35, // 프로 플랜과 동일
    maxAssignmentsPerMonth: null, // 무제한
    maxStorageMB: null, // 무제한
    maxQuizSets: 20, // 프로 플랜과 동일
    maxQuizCardsPerSet: 30, // 프로 플랜과 동일
    maxAlarmSets: 10, // 프로 플랜과 동일
    allowedAlarmCategories: ['basic', 'class'], // 모든 알람 카테고리
    maxNoteCategories: 5, // 프로 플랜과 동일
    maxMemberGroups: 15,
  },
};

export const getLicenseLimits = (userType: UserType): LicenseLimitConfig => {
  return LICENSE_LIMITS[userType] || LICENSE_LIMITS.free;
};

